var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-facial-header-wrapper"},[_c('div',{staticClass:"d-flex flex-grow-1",staticStyle:{"height":"100%","padding":"4rem"}},[_c('b-card',{staticClass:"box-back-white",staticStyle:{"width":"100%","height":"100%"}},[_vm._v("hi")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16674683","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/featured/facial.vue
// module id = 782
// module chunks = 1